import React from "react";
import { TabsLine } from "src/components/TeamDetailPage/PlaceholderStyles";

export const TabsPlaceholder = () => {
  return (
    <>
      <TabsLine data-testid="tab-placeholder-line" />
      <TabsLine data-testid="tab-placeholder-line" />
      <TabsLine data-testid="tab-placeholder-line" />
      <TabsLine data-testid="tab-placeholder-line" />
      <TabsLine data-testid="tab-placeholder-line" />
    </>
  );
};
